export const buildEnvironmentalLabel = ({ environmental_label: label }) => label
